// extracted by mini-css-extract-plugin
export default {"root":"_2JXXn","icon":"_1Gvxt","active-icon":"_2vIRk","activeIcon":"_2vIRk"};